module.exports = __webpack_public_path__ + "static/media/23.997de282.png";